var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Příjmy")]),_vm._v(" "),_c('LineChart',{attrs:{"url":"/api/reports/incomes","label":"Příjmy"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }